import { useEffect } from "react";
import { t } from "@/i18n-js/instance";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";
import Features from "../../SettingsApp/Plan/PlanSettings/Features";
import { PlanSelector } from "../../SettingsApp/Plan/PlanSettings/PlanSelector";
import { BillingCurrency } from "../../SettingsApp/Plan/RegularPlan/BillingCurrency";
import { BillingCycle } from "../../SettingsApp/Plan/RegularPlan/BillingCycle";
import { PlansProvider } from "../../SettingsApp/Plan/RegularPlan/PlansContext";

export const PlansModalBody = () => {
  const { trackEvent } = useEventsTracker();

  useEffect(() => {
    trackEvent("plan_settings.plans_modal.opened", {});
  }, []);

  return (
    <Modal.Body className="scrollbar-hide">
      <PlansProvider>
        <div className="mx-auto max-w-[960px]">
          <div className="flex flex-row flex-wrap items-center justify-between">
            <Typography.TitleSm weight="semibold">
              {t("pricing_plans.plans_modal.title")}
            </Typography.TitleSm>

            <div className="flex items-center">
              <BillingCurrency />
              <BillingCycle />
            </div>
          </div>
          <div className="mt-6">
            <PlanSelector />
          </div>
          <div className="mt-12">
            <Features />
          </div>
        </div>
      </PlansProvider>
    </Modal.Body>
  );
};
